import { Box } from "@mui/material"
import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import { ScheduleModal } from "./schedule/ScheduleModal";
import { useAPI } from "../../hooks/useAPI";
import { useAuth } from "../../assets/contexts/AuthContext";
import { CategoryData, CountryData, TemplateData } from "../../types";

export const ScheduleTemplate = () => {
  const { template_id } = useParams();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const isLoading = useRef(false);
  const { isAuthenticated } = useAuth();
  const { fetchData } = useAPI();
  const [template, setTemplate] = useState<TemplateData>({});
  const [countries, setCountries] = useState<CountryData[]>([]);
  const [categories, setCategories] = useState<CategoryData[]>([]);

  const handleClose = () => {
    setOpen(false);
    navigate('/templates');
  }

  const handleSave = () => {
    navigate('/templates');
  }

  useEffect(() => {
    if (isAuthenticated && !isLoading.current) {
      isLoading.current = true;

      fetchData(`/templates/${template_id}`).then(({ errors, data }) => {
        isLoading.current = false;
        setTemplate(data);
        setOpen(true);
      }).catch(error => {
        isLoading.current = false;
        console.log(error);
      })

      fetchData(`/countries/all`).then(({ errors, data }) => {
        setCountries(data);
      }).catch(error => {
        console.log(error);
      })

      fetchData(`/countries/all`).then(({ errors, data }) => {
        setCountries(data);
      }).catch(error => {
        console.log(error);
      })

      fetchData(`/categories/all`).then(({ errors, data }) => {
        setCategories(data);
      }).catch(error => {
        console.log(error);
      })
    }
  }, [isAuthenticated, template_id]);

  useEffect(() => {
    setOpen(true);
  }, []);

  return (
    <Box className="edit-template">
      <ScheduleModal 
        open={open} 
        handleClose={handleClose} 
        handleSave={handleSave} 
        clone={true} 
        template={template}
        countries={countries}
        categories={categories}
      />
    </Box>
  )
}